{
  "notifications": {
    "eyebrow": "帳戶",
    "title": "通知",
    "subtitle": "管理 BidNova 如何就出價、得標及發貨與你聯絡。",
    "notFound": "找不到頁面。",
    "pageTitle": "通知設定 — BidNova Auctions"
  },
  "bell": {
    "ariaUnread": "通知，{count} 則未讀",
    "ariaNoUnread": "通知",
    "title": "通知",
    "unreadCount": "{count} 則未讀",
    "allCaughtUp": "已全部閱覽",
    "markAllRead": "全部標為已讀",
    "empty": "暫無通知。",
    "settingsLink": "通知設定",
    "defaultTitle": "通知",
    "timeJustNow": "剛剛",
    "timeMinutes": "{count} 分鐘前",
    "timeHours": "{count} 小時前",
    "timeDays": "{count} 日前",
    "timeWeeks": "{count} 週前",
    "toastMarkOneError": "無法標為已讀",
    "toastMarkAllError": "無法全部標為已讀",
    "toastMarkAllSuccess": "已全部閱覽"
  },
  "prefs": {
    "eyebrow": "通知",
    "subtitle": "選擇你想如何接收 BidNova 的訊息。",
    "enableGlobalPush": "全域啟用瀏覽器推播",
    "addDevice": "新增此裝置",
    "sendTest": "傳送測試",
    "categoriesHeading": "分類",
    "eventsHeading": "事件",
    "colInApp": "站內",
    "colEmail": "電郵",
    "colPush": "推播",
    "devicesHeading": "裝置",
    "noDevices": "尚未登記任何推播裝置。",
    "removeDevice": "移除裝置",
    "failures": "{count} 次失敗",
    "toastPushNotConfigured": "推播功能尚未設定。",
    "toastPushDenied": "推播權限被拒絕。",
    "toastPushEnabled": "已在此裝置啟用推播通知",
    "toastTestSent": "測試通知已傳送（{count} 個渠道）",
    "category": {
      "pushMaster": "推播總開關",
      "auctionOutbid": "被超越出價",
      "auctionWon": "拍賣得標",
      "auctionLost": "拍賣落選",
      "endingSoon": "即將結束",
      "paymentReceived": "已收到付款",
      "paymentReleased": "款項已發放",
      "sellerMessage": "賣家訊息",
      "buyerMessage": "買家訊息",
      "systemUpdates": "系統更新",
      "securityAlerts": "安全警示",
      "weeklySummary": "每週摘要",
      "marketing": "推廣資訊（自選加入）"
    },
    "event": {
      "endingSoon": "拍賣即將結束",
      "priceDrop": "價格下調／即買價變動",
      "wantMatch": "求購清單有相符結果",
      "outbid": "你的出價被超越",
      "auctionWon": "拍賣得標",
      "auctionLost": "拍賣落選",
      "reserveMet": "已達底價",
      "paymentRequired": "需要付款",
      "paymentReceived": "已收到付款",
      "dispatchRequired": "賣家需要發貨",
      "itemDispatched": "商品已寄出",
      "trackingUpdate": "Royal Mail 追蹤更新",
      "deliveryConfirm": "送達確認",
      "payoutReleased": "款項已發放",
      "disputeUpdate": "爭議更新",
      "promotionActivated": "精選推廣已啟用",
      "reservationExpiring": "即買價保留即將到期",
      "watchlistNewBid": "追蹤清單中的拍賣有新出價",
      "auctionBelowReserve": "你的拍賣結束時未達底價",
      "refundCompleted": "退款已完成",
      "listingApproved": "上架已批准",
      "listingRejected": "上架需要修改"
    }
  },
  "watchlist": {
    "pageTitle": "追蹤清單",
    "eyebrow": "買家",
    "title": "追蹤清單",
    "subtitle": "你正在追蹤的卡牌，請在結束前出價。",
    "browseAuctions": "瀏覽拍賣",
    "errorDescription": "無法載入你的追蹤清單。",
    "emptyTitle": "你的追蹤清單是空的",
    "emptyDescription": "瀏覽進行中的拍賣，點擊心心圖示收藏你喜愛的卡牌。",
    "discoverCards": "探索卡牌"
  },
  "wantList": {
    "pageTitle": "求購清單 — BidNova Auctions",
    "pageDescription": "追蹤你正在尋找的卡牌，並配對至 BidNova 進行中的拍賣。",
    "title": "求購清單",
    "subtitle": "追蹤你正在尋找的卡牌——我們會為你標示相符的進行中拍賣。",
    "refreshMatches": "重新整理配對",
    "cardName": "卡牌名稱 *",
    "cardNamePlaceholder": "Charizard",
    "set": "系列",
    "setPlaceholder": "Base Set",
    "maxPrice": "最高價格（£）",
    "addButton": "加入求購清單",
    "yourWantList": "你的求購清單",
    "anySet": "任何系列",
    "active": "運作中",
    "paused": "已暫停",
    "pause": "暫停",
    "resume": "恢復",
    "noItemsYet": "尚未有項目。",
    "matches": "配對結果",
    "matched": "配對於 {date}",
    "noMatchesYet": "暫無配對結果 — 請點擊「重新整理配對」。",
    "toastAdded": "已加入求購清單",
    "toastMatchesFound": "找到 {count} 個配對"
  },
  "myBids": {
    "pageTitle": "我的出價",
    "eyebrow": "買家",
    "title": "我的出價",
    "errorDescription": "無法載入你的出價紀錄。",
    "emptyTitle": "你尚未出過任何價",
    "emptyDescription": "尋找你喜愛的卡牌，並出你的第一口價。",
    "browseAuctions": "瀏覽拍賣",
    "yourBid": "你的出價：{amount}",
    "won": "已得標 🎉",
    "ended": "已結束",
    "winning": "領先中",
    "outbid": "已被超越"
  },
  "myAuctions": {
    "pageTitle": "我的拍賣",
    "eyebrow": "賣家",
    "title": "我的拍賣",
    "subtitle": "管理你的進行中上架及查看過往銷售紀錄。",
    "listACard": "上架卡牌",
    "errorDescription": "無法載入你的上架項目。",
    "activeHeading": "進行中（{count}）",
    "endedHeading": "已結束（{count}）",
    "noActiveListings": "暫無進行中的上架項目，立即建立一個吧。",
    "nothingEndedYet": "尚未有已結束項目。",
    "bidsCount": "{count} 次出價",
    "endsOn": "結束於 {date}",
    "featuredUntil": "精選推廣至 {date}",
    "extend": "延長",
    "promote": "推廣"
  },
  "collection": {
    "pageTitle": "我的收藏 · BidNova",
    "pageDescription": "追蹤你擁有的卡牌、購入成本及估算收藏價值。",
    "eyebrow": "收藏管理",
    "title": "我的收藏",
    "subtitle": "獨立追蹤你擁有的卡牌，與你正在出售的區分開來。估算價值來自真實市場數據——若無市場數據，則只顯示購入成本。",
    "collectionsHeading": "收藏清單",
    "allItems": "所有項目",
    "newCollectionPlaceholder": "新增收藏清單",
    "noCardsYet": "尚未有卡牌，請建立收藏清單並新增第一張卡牌。",
    "untitledCard": "未命名卡牌",
    "quantityShort": "x{count}",
    "acquisitionShort": "購入 {amount}",
    "unarchive": "取消封存",
    "archive": "封存",
    "noValuationsYet": "尚未有估值資料。當你為卡牌執行估價建議後，估算價值將會顯示。",
    "cardsLabel": "卡牌數量",
    "acquisitionCostLabel": "購入成本",
    "estimatedValueLabel": "估算價值",
    "realisedProfitLabel": "已實現利潤",
    "addACard": "新增卡牌",
    "cardNameLabel": "卡牌名稱",
    "setLabel": "系列",
    "quantityLabel": "數量",
    "acquisitionCostPoundLabel": "購入成本（£）",
    "graded": "已評級",
    "addCardButton": "新增卡牌"
  }
}
